/**
 * Незавершённые вертикальные срезы не должны выглядеть рабочими.
 * Флаг включается только вместе с API, серверными правами и проверками.
 */

/*
 * Звонки зависят не только от кода: браузер подключается к wss://rtc.andresot.ru,
 * и без этого имени в DNS ни один звонок не состоится. Поэтому флаг задаётся
 * при сборке образа — там, где известно состояние конкретной площадки.
 *
 * Значение по умолчанию — включено: в разработке и в тестах переменной нет,
 * и поведение остаётся прежним. Выключается только явным 'false'.
 */
const callsEnabled = import.meta.env.VITE_CALLS_ENABLED !== 'false';
const videoEnabled = import.meta.env.VITE_VIDEO_ENABLED !== 'false';
const datingEnabled = import.meta.env.VITE_DATING_ENABLED !== 'false';

export const featureFlags = {
	classifieds: import.meta.env.VITE_CLASSIFIEDS_ENABLED !== 'false',
	music: import.meta.env.VITE_MUSIC_ENABLED !== 'false',
	qrLogin: true,
	stories: true,
	calls: callsEnabled,
	contacts: true,
	chatCreation: true,
	chatManagement: true,
	chatPreferences: true,
	chatSearch: true,
	polls: true,
	accountEditing: true,
	securitySettings: true,
	devices: true,
	admin: true,
	mail: true,
	premium: true,
	gifts: true,
	video: videoEnabled,
	dating: datingEnabled
} as const;
